import { render, staticRenderFns } from "./date-editor.vue?vue&type=template&id=5c235654&"
import script from "./date-editor.vue?vue&type=script&lang=js&"
export * from "./date-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports